import SelectFilterModal from './SelectFilterModal'
import useGminaFilterModal from '../hooks/useGminaFilterModal'

export default function GminaFilterModal({
	isOpen,
	onClose,
	selectedGminaId,
	idPowiat = null,
	idWojewodztwo = null,
	onApply,
	title = 'Filtruj po gminie',
	description = 'Wybierz gmine, aby zawezic liste placowek.',
	applyLabel = 'Zastosuj',
	clearLabel = 'Wyczysc filtr',
}) {
	const state = useGminaFilterModal(isOpen, selectedGminaId, idPowiat, idWojewodztwo)
	return (
		<SelectFilterModal
			isOpen={isOpen}
			onClose={onClose}
			onApply={onApply}
			title={title}
			description={description}
			placeholder="Szukaj gminy po nazwie..."
			emptyMessage="Nie znaleziono gmin"
			applyLabel={applyLabel}
			clearLabel={clearLabel}
			{...state}
		/>
	)
}
